import { differenceInMinutes } from 'date-fns'
import { assertNever } from '@omnea-app/packages/universal/type-guards/assertNever'

export type RequestDisplayStatus = 'pending' | 'completed' | 'rejected' | 'paused'

type RequestDurationInput = {
  createdAt: string
  completedAt: string | null
  pausedAt: string | null
  status: RequestDisplayStatus
}

type RequestDuration = {
  days: number
  hours: number
  minutes: number
}

export const calculateRequestDuration = (request: RequestDurationInput): RequestDuration | null => {
  const createdDate = new Date(request.createdAt)

  if (isNaN(createdDate.getTime())) {
    return null
  }

  let endDate: Date

  switch (request.status) {
    case 'completed':
    case 'rejected':
      if (!request.completedAt) {
        return null
      }
      endDate = new Date(request.completedAt)
      break

    case 'paused':
      if (!request.pausedAt) {
        return null
      }
      endDate = new Date(request.pausedAt)
      break

    case 'pending':
      endDate = new Date()
      break

    default:
      assertNever(request.status)
      return null
  }

  if (isNaN(endDate.getTime()) || endDate < createdDate) {
    return null
  }

  const totalMinutes = differenceInMinutes(endDate, createdDate)

  const days = Math.floor(totalMinutes / (24 * 60))
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60)
  const minutes = totalMinutes % 60

  return { days, hours, minutes }
}
